import { api } from './api';

export interface CreateGuidedIntakeRequest {
  patient_id: string;
  clinic_program_option_id: string;
  patient_email?: string;
  send_email?: boolean;
  referring_user_id?: string | null;
  commission_rate_bps?: number | null;
}

export interface CreateGuidedIntakeResponse {
  success: boolean;
  data?: {
    id: string;
    guided_order_id: string;
    status: string;
    message?: string;
  };
  error?: { message?: string; code?: string };
}

/**
 * Create a guided enrollment: creates a guided order and sends the enrollment link.
 * For guided clinics only.
 */
export async function createGuidedIntake(
  clinicId: string,
  body: CreateGuidedIntakeRequest
): Promise<CreateGuidedIntakeResponse> {
  // api.post already returns response.data (body); return it as-is so success/data are preserved
  return api.post<CreateGuidedIntakeResponse>(
    `/clinic/${clinicId}/guided-intake`,
    body
  );
}
